<app-subheader-main [showProjects]="false" [showBreadCrumb]="false" [showFamilyBreadCrumb]="false"></app-subheader-main>
<div class="ft-form">
    <div class="content">
        <div class="ft-form-row">
            <div class="ft-form-row col1-v100">                     
              <span class="title">
                {{"lbl_manage_trees"| translate}}
              </span>
            </div>
        </div>     
        <div class="list-gallery">
            <app-family-project-list
            [items]="mediaListItems"
            (action)="dropMenuAction($event)"
            ></app-family-project-list>  
        </div>     
    </div>
    <div class="footer">
        <button class = "ft-btn ft-btn-active" (click)="openAddNewProjectMain(1, [1,2])">{{"lbl_create_new_tree"|translate}}</button>                
        <button class = "ft-btn" [ngClass]="'ft-btn-active'"  (click)="showFamilyList()">{{"lbl_updatePage" | translate}}</button>
    </div>
</div>